import React, { Component } from 'react';

export const RESIZER_ORIENTATION_HORIZONTAL = 'horizontal';
export const RESIZER_ORIENTATION_VERTICAL = 'vertical';
export const RESIZER_EXPAND_FIRST = 'first';
export const RESIZER_EXPAND_LAST = 'last';

export default class Resizer extends Component {
  constructor(props) {
    super(props);
    this._onMouseDown = this._onMouseDown.bind(this);
    this._onMouseMove = this._onMouseMove.bind(this);
    this._onMouseUp = this._onMouseUp.bind(this);
    this.state = { size: props.size || 200 };
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this._onMouseMove);
    window.removeEventListener('mouseup', this._onMouseUp);
  }

  _onMouseDown(e) {
    e.preventDefault();
    window.addEventListener('mousemove', this._onMouseMove);
    window.addEventListener('mouseup', this._onMouseUp);
  }

  _onMouseMove(e) {
    e.preventDefault();
    let delta;
    if (this.props.orientation === RESIZER_ORIENTATION_HORIZONTAL) {
      delta = e.movementX;
    } else if (this.props.orientation === RESIZER_ORIENTATION_VERTICAL) {
      delta = e.movementY;
    } else {
      throw new Error(`Invalid orientation ${this.props.orientation}.`);
    }
    if (this.props.expand === RESIZER_EXPAND_LAST) {
      delta = -delta;
    }

    this.setState({ size: this.state.size + delta });
  }

  _onMouseUp(e) {
    e.preventDefault();
    window.removeEventListener('mousemove', this._onMouseMove);
    window.removeEventListener('mouseup', this._onMouseUp);
  }

  render() {
    const { children, orientation, expand } = this.props;
    const { size } = this.state;
    let gridProperty;
    if (orientation === RESIZER_ORIENTATION_HORIZONTAL) {
      gridProperty = 'gridTemplateColumns';
    } else if (orientation === RESIZER_ORIENTATION_VERTICAL) {
      gridProperty = 'gridTemplateRows';
    } else {
      throw new Error(`Invalid orientation ${orientation}.`);
    }
    let gridValue;
    if (expand === RESIZER_EXPAND_LAST) {
      gridValue = `1fr 5px ${size}px`;
    } else {
      gridValue = `${size}px 5px 1fr`;
    }
    return (
      <div className={`resizer ${orientation}`} style={{ [gridProperty]: gridValue }}>
        {children[0]}
        <div className="resizer__dragger" onMouseDown={this._onMouseDown} />
        {children[1]}
      </div>
    );
  }
}
